/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NftGenerateModel from './NftGenerateModel';

/**
 * The NftGeneratorControllerDtoNftImageGenerateRequest model module.
 * @module model/NftGeneratorControllerDtoNftImageGenerateRequest
 * @version 1.0
 */
class NftGeneratorControllerDtoNftImageGenerateRequest {
    /**
     * Constructs a new <code>NftGeneratorControllerDtoNftImageGenerateRequest</code>.
     * @alias module:model/NftGeneratorControllerDtoNftImageGenerateRequest
     */
    constructor() { 
        
        NftGeneratorControllerDtoNftImageGenerateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftGeneratorControllerDtoNftImageGenerateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftGeneratorControllerDtoNftImageGenerateRequest} obj Optional instance to populate.
     * @return {module:model/NftGeneratorControllerDtoNftImageGenerateRequest} The populated <code>NftGeneratorControllerDtoNftImageGenerateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftGeneratorControllerDtoNftImageGenerateRequest();

            if (data.hasOwnProperty('startNftUid')) {
                obj['startNftUid'] = ApiClient.convertToType(data['startNftUid'], 'Number');
            }
            if (data.hasOwnProperty('endNftUid')) {
                obj['endNftUid'] = ApiClient.convertToType(data['endNftUid'], 'Number');
            }
            if (data.hasOwnProperty('collaboInfoList')) {
                obj['collaboInfoList'] = ApiClient.convertToType(data['collaboInfoList'], [NftGenerateModel]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftGeneratorControllerDtoNftImageGenerateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftGeneratorControllerDtoNftImageGenerateRequest</code>.
     */
    static validateJSON(data) {
        if (data['collaboInfoList']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['collaboInfoList'])) {
                throw new Error("Expected the field `collaboInfoList` to be an array in the JSON data but got " + data['collaboInfoList']);
            }
            // validate the optional field `collaboInfoList` (array)
            for (const item of data['collaboInfoList']) {
                NftGenerateModel.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} startNftUid
 */
NftGeneratorControllerDtoNftImageGenerateRequest.prototype['startNftUid'] = undefined;

/**
 * @member {Number} endNftUid
 */
NftGeneratorControllerDtoNftImageGenerateRequest.prototype['endNftUid'] = undefined;

/**
 * @member {Array.<module:model/NftGenerateModel>} collaboInfoList
 */
NftGeneratorControllerDtoNftImageGenerateRequest.prototype['collaboInfoList'] = undefined;






export default NftGeneratorControllerDtoNftImageGenerateRequest;

